import { render, staticRenderFns } from "./ScriptPathEditDialog.vue?vue&type=template&id=0b3c200d&scoped=true&"
import script from "./ScriptPathEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ScriptPathEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptPathEditDialog.vue?vue&type=style&index=0&id=0b3c200d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c200d",
  null
  
)

export default component.exports